module.exports = __webpack_public_path__ + "img/Glasgow_City.5ce35b8a.png";